function getColumns() {
	let arr = [
		{
			label: '商品信息',
			type: () => import('./component/tableCells/goodsInfoCell.vue'),
			minWidth: 340,
			fixed: 'left',
		},
		{
			key: '',
			label: '活动信息',
			type: () => import('./component/tableCells/activityCell.vue'),
			minWidth: 280,
		},
		{
			label: '现跟进人',
			type: () => import('./component/tableCells/textCell.vue'),
			width: 100,
			propType: 'newUserName',
		},
		{
			label: '原跟进人',
			type: () => import('./component/tableCells/textCell.vue'),
			width: 100,
			propType: 'oldUserName',
		},
		{
			key: 'remark',
			label: '动态',
			width: 120,
			type: () => import('./component/tableCells/textCell.vue'),
			propType: 'remark',
		},
		{
			key: 'actionTypeText',
			label: '动态类型',
			width: 110,
			type: () => import('./component/tableCells/textCell.vue'),
			propType: 'actionTypeText',
		},

		{
			key: 'addTime',
			label: '时间',
			width: 140,
			type: () => import('./component/tableCells/timeCell.vue'),
		},
	];
	return arr;
}
export default getColumns;
